import Icon from './icon';
import './icon.scss';

export default Icon;
